import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-2xl px-4 py-8 mx-auto sm:py-8 sm:px-6 lg:max-w-7xl lg:px-8" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-2 gap-y-4 sm:grid-cols-3 gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8"
}
const _hoisted_4 = { class: "bg-gray-200 group-hover:opacity-75 aspect-square" }
const _hoisted_5 = ["alt", "src"]
const _hoisted_6 = { class: "flex flex-col flex-1 p-4 space-y-2" }
const _hoisted_7 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "text-sm text-clay-800" }
const _hoisted_10 = { class: "flex flex-col justify-end flex-1" }
const _hoisted_11 = { class: "text-base font-medium text-gray-900" }
const _hoisted_12 = {
  key: 1,
  class: "grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8"
}

import {defineComponent, onMounted, ref, Ref} from "vue";
import {client} from '@/shared';
import {GetRelatedProductsFromAmazon, RelatedProductFromAmazonDto} from "@/dtos";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedProductsFromAmazon',
  props: {
  searchTerm: String
},
  setup(__props) {

// @ts-ignore
const props = __props
let searchTerm: Ref<String> = ref(props.searchTerm);
let products: Ref<Array<RelatedProductFromAmazonDto>> = ref(new Array<RelatedProductFromAmazonDto>());

const productsRetrieved = ref(false);

onMounted(async () => {
  await client.get<Array<RelatedProductFromAmazonDto>>(new GetRelatedProductsFromAmazon({title: searchTerm.value}))
      .then((res) => {
        products.value = res;
        productsRetrieved.value = true;
      })
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (productsRetrieved.value === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(products))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.asin,
                    class: "relative flex flex-col overflow-hidden bg-white border border-gray-200 rounded-lg group"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        alt: product.coverUrl,
                        src: product.coverUrl,
                        class: "object-cover mx-auto sm:w-full aspect-square rounded-2xl max-w-80 w-full"
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", _hoisted_7, [
                        _createElementVNode("a", {
                          href: product.itemUrl
                        }, [
                          _cache[0] || (_cache[0] = _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: "absolute inset-0"
                          }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(product.productGroup), 1)
                        ], 8, _hoisted_8)
                      ]),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(product.title), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(product.price), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[1] || (_cache[1] = [
                _createElementVNode("p", null, "Sorry, we currently do not have any related products.", -1)
              ])))
        ]))
      : (_openBlock(), _createBlock(SkeletonCard, {
          key: 1,
          "card-style": "long",
          "num-of-cards": 4
        }))
  ]))
}
}

})